import { login, reg } from '@/api/login'
import { getUserInfoApi, setUserInfoApi, saveUserCollect } from '@/api/user'
import { getUserAddress, saveUserAddress } from '@/api/address'
import { setToken, removeToken, setGlobalToken, removeGlobalToken } from '@/utils/auth'
import router from '@/router'
import { ERROR_STRING, CONFERENCE_ID_SPECIAL } from '@/utils/constant'

const user = {
  state: {
    token: '',
    userInviteCode: '',
    userType: '',
    userId: '',
    userCheckinCode: '',
    userRealname: '',
    conferenceId: '',
    conferenceName: '',
    userCompanyName: '',
    userPosition: '',
    userCellphone: '',
    addressList: [],
    isShowSubData: 'n', // 是否显示下级数据（我的客户）
    conferenceList: [],
    selectedConference: {},
    selectedConferenceId: '',
    selectedBrandId: '',
    webView: ''
  },
  mutations: {
    SET_USER_INFO: (state, data) => {
      state.token = data.token
      state.userInviteCode = data.userInviteCode
      state.userType = data.userType
      state.userId = data.userId
      state.userCheckinCode = data.userCheckinCode
      state.userRealname = data.userRealname
      state.conferenceId = data.conferenceId
      state.conferenceName = data.conferenceName
      state.conferenceList = data.conferenceList
    },
    Add_USER_INFO: (state, data) => {
      state.userRealname = data.userRealname
      state.userCompanyName = data.userCompanyName
      state.userCellphone = data.userCellphone
      state.isShowSubData = data.isShowSubData
      state.userPosition = data.userPosition
      if (data.userInfo2) {
        state.conferenceList = data.userInfo2.conferenceList
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ADDRESS: (state, data) => {
      state.addressList = data
    },
    SET_SELECTED_CONFERENCE: (state, data) => {
      state.selectedConference = data
    },
    SET_SELECTED_CONFERENCE_ID: (state, data) => {
      state.selectedConferenceId = data
    },
    SET_SELECTED_BRAND_ID: (state, data) => {
      state.selectedBrandId = data
    },
    SET_WEBVIEW: (state, data) => {
      state.webView = data;
    }
  },
  actions: {
    // 登录
    Login ({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data).then(response => {
          // console.log(response)
          let res = response.data
          if (res.erroyCode === 200) {
            const data = JSON.parse(res.data)
            setToken(data.token)
            setGlobalToken(data.token)
            commit('SET_USER_INFO', data)
            localStorage.setItem('user', JSON.stringify(data))
            console.log(data)
            // if (data && data.conferenceList && data.conferenceList.length === 1) {
            //   console.log('SET_SELECTED_CONFERENCE_ID', data.conferenceList[0].conferenceId)
            //   commit('SET_SELECTED_CONFERENCE', data.conferenceList[0])
            //   commit('SET_SELECTED_CONFERENCE_ID', data.conferenceList[0].conferenceId)
            //   commit('SET_SELECTED_BRAND_ID', data.conferenceList[0].brandId)
            //   // selectedBrandId
            // }
            if (window.plus) {
              plus.storage.setItem("ordring-system", JSON.stringify(data));
              plus.storage.setItem("shareing-info", JSON.stringify({
                title: '订货演示（仅演示用）',
                summary: '',
                imageUrl: 'https://d.fzzht.com/wx_share_logo_spring.png'
              }));
            }
            resolve(data)
          } else {
            reject(res)
          }
        }).catch(error => {
          console.log(error)
          reject(ERROR_STRING)
        })
      })
    },
    // 收集信息 并 注册
    Register({ commit }, data) {
      return new Promise((resolve, reject) => {
        reg(data).then(response => {
          // console.log(response)
          let res = response.data
          if (res.erroyCode === 200) {
            const data = JSON.parse(res.data)
            setToken(data.token)
            setGlobalToken(data.token)
            commit('SET_USER_INFO', data)
            localStorage.setItem('user', JSON.stringify(data))
            console.log(data)
            // if (data && data.conferenceList && data.conferenceList.length === 1) {
            //   console.log('SET_SELECTED_CONFERENCE_ID', data.conferenceList[0].conferenceId)
            //   commit('SET_SELECTED_CONFERENCE', data.conferenceList[0])
            //   commit('SET_SELECTED_CONFERENCE_ID', data.conferenceList[0].conferenceId)
            //   commit('SET_SELECTED_BRAND_ID', data.conferenceList[0].brandId)
            //   // selectedBrandId
            // }
            if (window.plus) {
              plus.storage.setItem("ordring-system", JSON.stringify(data));
              plus.storage.setItem("shareing-info", JSON.stringify({
                title: '订货演示（仅演示用）',
                summary: '',
                imageUrl: 'https://d.fzzht.com/wx_share_logo_spring.png'
              }));
            }
            resolve(data)
          } else {
            reject(res)
          }
        }).catch(error => {
          console.log(error)
          reject(ERROR_STRING)
        })
      })
    },
    // 获取本地个人信息
    GetLocalUserInfo ({ commit, state }) {
      if (localStorage.getItem('user')) {
        let userData = JSON.parse(localStorage.getItem('user'))
        let brandId = localStorage.getItem('brand_id')
        console.log(userData,'=====')
        commit('SET_USER_INFO', userData)
        if (userData && userData.conferenceList && userData.conferenceList.length === 1) {
          commit('SET_SELECTED_CONFERENCE', userData.conferenceList[0])
          commit('SET_SELECTED_CONFERENCE_ID', userData.conferenceList[0].conferenceId)
          commit('SET_SELECTED_BRAND_ID', userData.conferenceList[0].brandId)
          console.log('SET_SELECTED_CONFERENCE_ID', userData.conferenceList[0].conferenceId)
        } 
        // if (userData) {
        //   // commit('SET_SELECTED_CONFERENCE_ID', userData.conferenceId)
        //   // commit('SET_SELECTED_BRAND_ID', brandId)
        //   // console.log('SET_SELECTED_CONFERENCE_ID', userData.conferenceList[0].conferenceId)
        // } 
        else {
          // let selectedConferenceId = sessionStorage.getItem('selected_conferenceid')
          // if (selectedConferenceId) {
          //   commit('SET_SELECTED_CONFERENCE_ID', selectedConferenceId)
          //   if (userData && userData.conferenceList) {
          //     let selectedConference = userData.conferenceList.filter(item => {
          //       if (item.conferenceId === selectedConferenceId) {
          //         return item
          //       }
          //     })
          //     commit('SET_SELECTED_CONFERENCE', selectedConference[0])
          //   }
          // }
        }
      }
      // if (localStorage.getItem('user_add')) {
      //   let UserAddData = JSON.parse(localStorage.getItem('user_add'))
      //   commit('Add_USER_INFO', UserAddData)
      //   if (UserAddData && UserAddData.userInfo2 && UserAddData.userInfo2.conferenceList.length === 1) {
      //     commit('SET_SELECTED_CONFERENCE', UserAddData.userInfo2.conferenceList[0])
      //     commit('SET_SELECTED_CONFERENCE_ID', UserAddData.userInfo2.conferenceList[0].conferenceId)
      //     commit('SET_SELECTED_BRAND_ID', UserAddData.userInfo2.conferenceList[0].brandId)
      //   } else {
      //     let selectedConferenceIdAdd = sessionStorage.getItem('selected_conferenceid')
      //     if (selectedConferenceIdAdd) {
      //       commit('SET_SELECTED_CONFERENCE_ID', selectedConferenceIdAdd)
      //       if (UserAddData && UserAddData.userInfo2 && UserAddData.userInfo2.conferenceList) {
      //         let selectedConferenceAdd = UserAddData.userInfo2.conferenceList.filter(item => {
      //           if (item.conferenceId === selectedConferenceIdAdd) {
      //             return item
      //           }
      //         })
      //         commit('SET_SELECTED_CONFERENCE', selectedConferenceAdd[0])
      //       }
      //     }
      //   }
      // }
    },
    // 获取用户信息
    GetUserInfo ({ commit }, data) {
      return new Promise((resolve, reject) => {
        getUserInfoApi(data).then(response => {
          console.log(response)
          if (response.erroyCode === 200) {
            const data = JSON.parse(response.data)
            commit('Add_USER_INFO', data)
            localStorage.setItem('user_add', JSON.stringify(data))
            if (window.plus) {
              plus.storage.setItem("ordring-system-add", JSON.stringify(data));
            }
            resolve(data)
          } else {
            reject(response.erroyMsg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设置用户信息
    SetUserInfo ({ commit }, data) {
      return new Promise((resolve, reject) => {
        setUserInfoApi(data).then(response => {
          console.log(response)
          if (response.erroyCode === 200) {
            const data = JSON.parse(response.data)
            resolve(data)
          } else {
            reject(response.erroyMsg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LoginOut ({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        removeToken()
        removeGlobalToken()
        setTimeout(() => {
          let brandId = localStorage.getItem('brand_id')
          sessionStorage.clear()
          localStorage.clear()
          if (state.webView == 'yjjapp') {
            router.replace('/login?brand=' + brandId + '&conference=' + state.conferenceId + '&code=' + state.userInviteCode + '&logintype=login&loginphone=' + state.userCellphone)
          } else if (state.conferenceId == CONFERENCE_ID_SPECIAL) {
            router.replace('/n-login?brand=' + brandId + '&conference=' + state.conferenceId + '&code=' + state.userInviteCode + '&logintype=login')
          } else {
            router.replace('/login?brand=' + brandId + '&conference=' + state.conferenceId + '&code=' + state.userInviteCode + '&logintype=login')
          }
          // router.replace('/login?brand=' + brandId + '&conference=' + state.conferenceId + '&code=' + state.userInviteCode + '&logintype=login')
          resolve()
        }, 1000)
      })
    },
    // 获取地址列表
    GetUserAddress ({commit, state}) {
      return new Promise((resolve, reject) => {
        getUserAddress(state.userId).then(response => {
          // console.log(response)
          const data = response.dto
          commit('SET_USER_ADDRESS', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新或添加收货地址
    SaveUserAddress ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        saveUserAddress(data).then(response => {
          // console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加或取消个人收藏
    SaveUserCollect ({commit}, data) {
      return new Promise((resolve, reject) => {
        saveUserCollect(data).then(response => {
          // console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js